export const Spinner = () => (
  <div className="lds-ring">
    <div />
    <div />
    <div />
    <div />
  </div>
);

export const SpinnerBlock = () => (
  <div className="container">
    <div className="row">
      <div className="col text-center mt-8 mb-8">
        <Spinner />
      </div>
    </div>
  </div>
);

export default Spinner;
